import React from 'react'
import clsx from 'clsx'
import styles from './PageTabItem.module.scss'

export interface PageTab {
    id: string
    label: string
    icon: string
    href?: string
    disabled?: boolean
}

export interface PageTabItemProps {
    tab: PageTab
    isActive: boolean
    isDisabled: boolean
    onClick: () => void
    compactMode: boolean
    compactOnMediumScreensAndBelow: boolean
    centered: boolean
}

export const PageTabItem = ({
    tab,
    isActive,
    isDisabled,
    onClick,
    compactMode,
    compactOnMediumScreensAndBelow,
    centered,
}: PageTabItemProps) => {
    const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        if(isDisabled) {
            event.preventDefault()
            return
        }

        onClick()
    }

    return (
        <a
            href={tab.href}
            aria-disabled={isDisabled}
            className={clsx(styles.pageTabItem, 'm-no-drag', {
                [styles.compactOnMediumScreensAndBelow]: compactOnMediumScreensAndBelow,
                [styles.active]: isActive,
                [styles.centered]: centered,
                [styles.compactMode]: compactMode,
                [styles.disabled]: isDisabled,
            })}
            onClick={handleClick}
        >
            <img src={tab.icon} alt={tab.label} className={styles.icon} />
            <span className={styles.label}>{tab.label}</span>
        </a>
    )
}
